import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiCall, Base_URL } from "../../Common/Path";

let refreshTokenInterval = null;

const refreshTokenDirectCall = async () => {
  try {
    const storedRefreshToken = localStorage.getItem("refreshToken");
    const currentAccessToken = localStorage.getItem("token");
    
    if (!storedRefreshToken) {
      localStorage.clear();
      return;
    }
    
    const response = await axios.post(`${Base_URL}/auth/refresh`, {
      refreshToken: storedRefreshToken,
    }, {
      headers: {
        'Authorization': `Bearer ${storedRefreshToken}`
      }
    });
    
    if (response.status === 201) {
      const newAccessToken = response.data?.data.accessToken;
      localStorage.setItem("token", newAccessToken);
    } else {
      localStorage.clear();
    }
  } catch (error) {
    localStorage.clear();
  }
};

export const UserSignIn = createAsyncThunk(
  "UserSignIn",
  async (body, thunkAPI) => {
    try {
      const response = await axios.post(`${Base_URL}/auth/signin`, body);
      // Handle new nested structure: response.data.data contains accessToken and refreshToken
      const { accessToken, refreshToken } = response.data.data || response.data;
      thunkAPI.dispatch({
        type: "user/setAuthDetails",
        payload: { token: accessToken, email: body.email, refreshToken },
      });

      if (refreshTokenInterval) {
        clearInterval(refreshTokenInterval);
      }

      refreshTokenInterval = setInterval(() => {
        refreshTokenDirectCall();
      }, 600000);

      return { responseData: response.data, requestBody: body };
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

export const ForgotPassword = createAsyncThunk("ForgotPassword", async (email) => {
  const body = { email };
  const result = await ApiCall(`${Base_URL}/auth/forgot-password-email`, body, "Post");
  return result;
});

export const VerifyForgotPasswordCode = createAsyncThunk("VerifyForgotPasswordCode", async (body) => {
  const result = await ApiCall(`${Base_URL}/auth/verify-forgot-password-code`, body, "Post");
  return result;
});

export const UpdatePassword = createAsyncThunk("UpdatePassword", async (body) => {
  const result = await ApiCall(`${Base_URL}/auth/forgot-password-set-new`, body, "Post");
  return result;
});

export const GetResendCode = createAsyncThunk("GetResendCode", async (email, { getState }) => {
  const token = getState().user.token;
  const result = await ApiCall(`${Base_URL}/auth/forgot-password-email`, { email }, "Post", token);
  return result;
});

export const VerifyCode = createAsyncThunk("VerifyCode", async (body) => {
  const result = await ApiCall(`${Base_URL}/auth/verify-otp`, body, "Post");
  return result;
});

export const GetUserRoles = createAsyncThunk("GetUserRoles", async () => {
  try {
    const response = await ApiCall(`${Base_URL}/users/roles?portal=MANAGER`);
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});

export const GetParentsRoles = createAsyncThunk("GetParentsRoles", async () => {
  try{
  const result = await ApiCall(`${Base_URL}/users/child-parent-roles`, null, "get");
  return result;
}catch (error) {
  throw error.response ? error.response.data : error.message;
}
});

export const SwitchRole = createAsyncThunk("SwitchRole", async (body) => {
  try {
    const result = await ApiCall(`${Base_URL}/auth/switch-role`, body, "Post");
    return result;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});

export const LogOut = createAsyncThunk("LogOut", async (payload, thunkAPI) => {
  clearInterval(refreshTokenInterval);
  localStorage.clear();
  thunkAPI.dispatch({
    type: "user/clearAuthDetails",
  });
  return payload;
});
